<template>
  <div>
    <button class="button is-secondary cta" href="#" @click.prevent="loadWidget()">Book Now</button>
  </div>
</template>
<script>
import axios from 'axios';
export default {
  props: {
    brand: String,
    tourId: String,
    optionId: String,
    departureId: String,
    regions: String,
    room: String,
    discountCode: String,
    marketVariation: String,
    sellingCompanyCode: String,
    itineraryVariationLink: String,
    quid: String,
    tripNotAvailableCtaUrl: String,
    dateNotAvailableCtaUrl: String,
    quoteEmailViewUrlCtaUrl: String,
    shoppingCartScript: String
  },
  computed: {
    basketProps() {
      return {
        brand: this.brand,
        tourId: String(this.tourId),
        optionId: String(this.optionId),
        departureId: this.departureId,
        regions: [this.regions],
        room: this.room?.toUpperCase(),
        adults: 1,
        epd: !!this.discountCode, // early booking discount
        discountCode: this.discountCode, // discount code for epd
        marketVariation: this.marketVariation,
        sellingCompanyCode: this.sellingCompanyCode,
        itineraryVariationLink: this.itineraryVariationLink, // TODO, currently undefined
        handleCloseBookingWidget: this.handleCloseBookingWidget,
        setWidgetMinimizeState: this.setWidgetMinimizeState,
        quid: this.quid, // TODO, currently undefined
        platformName: 'WL',
        role: 'WL',
        ctaUrls: {
          tripNotAvailable: this.tripNotAvailableCtaUrl, // TODO, currently undefined
          dateNotAvailable: this.dateNotAvailableCtaUrl, // TODO, currently undefined
          quoteEmailViewUrl: this.quoteEmailViewUrlCtaUrl // TODO, currently undefined
        }
      };
    }
  },
  methods: {
    book(booknowurl) {
      this.dataLayerBookNowClicked();
      axios
        .post(booknowurl, null, {
          headers: { 'Content-Type': 'application/json' }
        })
        .then(function (response) {
          window.location = response.data.url;
        })
        .catch(function (error) {});
    },
    dataLayerBookNowClicked() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'Book Now Clicked' });
    },
    loadWidget() {
      const mountWidget = () => {
        this.handleOpenBookingWidget();
        // console.log('basketProps', this.basketProps);
        window.bookingWidget?.mount('booking-widget', this.basketProps);
      };

      if (!document.getElementById('booking-widget-script')) {
        const script = document.createElement('script');
        script.src = this.shoppingCartScript;
        script.id = 'booking-widget-script';
        script.onload = mountWidget;
        document.body.appendChild(script);
      } else {
        mountWidget();
      }
    },
    handleCloseBookingWidget() {
      const wrapper = document.getElementById('booking-widget');
      if (wrapper) {
        wrapper.style.display = 'none';
      }
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    },
    handleOpenBookingWidget() {
      if (!document.getElementById('booking-widget')) {
        const wrapper = document.createElement('div');
        wrapper.id = 'booking-widget';
        document.body.appendChild(wrapper);
      }
      const wrapper = document.getElementById('booking-widget');
      if (wrapper) {
        wrapper.style.display = 'block';
        wrapper.style.position = 'fixed';
        wrapper.style.zIndex = '99';
        wrapper.style.background = '#00000088';
        wrapper.style.width = '100vw';
        wrapper.style.height = '100vh';
        wrapper.style.top = '0';
        wrapper.style.left = '0';
      }
    },
    setWidgetMinimizeState() {}
  }
};
</script>
